<template>
  <div id="app">
    <v-app style="background-color: #E1E1E1">
      <!-- NOTIFICATIONS -->
      <GlobalSnackbar />
      <notifications />
      <!-- CONTENT -->
      <router-view/>
      <!-- LOADING REQUESTS -->
      <v-progress-circular v-show="$store.state.requests" size="60" color="deep-orange" indeterminate style="position:absolute;bottom:20px;left:50%;margin-left:-30px;"></v-progress-circular>
    </v-app>
  </div>
</template>

<script>
import Notifications from './components/Notifications';
import GlobalSnackbar from './components/GlobalSnackbar';

export default {
  components: { GlobalSnackbar, Notifications },
  mounted () {
  },
}
</script>

<style>
@import "assets/app.scss";

#app {
  font-family: 'Calibri', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #666;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.br { border-radius:8px!important; }

.btr { border-radius:8px 8px 0 0 !important; }

.border { border:1px solid rgba(0,0,0,0.12)!important; }

.ellipsify {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 100%;
}

.bgalpha { background-color: rgba(0,0,0,0.05); }

.v-input__prepend-inner { margin-top:7px!important; }
.v-text-field .v-input { padding: 0px !important; }
.v-text-field input { font-size:11pt!important; }
.v-text-field--filled input { margin-top: 12px!important; }
.v-text-field .v-input__control .v-input__slot { min-height: auto !important; padding: 8px; }
.v-text-field .v-label { top:12px!important; }
.v-input__control .v-input__slot { padding:0 8px!important; }
</style>
